var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 173.252C58.5774 173.252 25 139.689 25 98.2835C25 56.8782 58.5774 23.3148 100 23.3148C141.423 23.3148 175 56.8782 175 98.2835C175 139.689 141.423 173.252 100 173.252Z",
    fill: "url(#paint0_linear_26801_4451)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.445 142.191C158.799 143.539 158.582 144.98 157.794 146.129C136.39 177.359 89.0276 187.822 60.567 162.475C59.8652 161.85 59.3737 161.021 59.1369 160.112C51.9508 132.518 45.3616 99.9997 38.1541 72.5751C37.4125 69.7478 39.4188 66.8227 42.6352 66.0381C70.7036 59.1943 98.7728 52.3525 126.841 45.5097C130.06 44.7251 133.269 46.3794 134.013 49.2068C142.156 80.202 150.301 111.196 158.445 142.191Z",
    fill: "url(#paint1_linear_26801_4451)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.942 63.9412L60.6445 78.7157C59.598 78.9764 58.5345 78.3526 58.2697 77.3221C58.0048 76.2916 58.6385 75.2449 59.6853 74.9842L118.983 60.2097C120.029 59.949 121.093 60.5728 121.358 61.6033C121.622 62.6338 120.988 63.6805 119.942 63.9412Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.588 78.1204L64.2905 92.8949C63.244 93.1556 62.1805 92.5318 61.9157 91.5013C61.6508 90.4708 62.2845 89.4241 63.3313 89.1634L122.629 74.3889C123.675 74.1282 124.739 74.752 125.004 75.7825C125.268 76.813 124.634 77.8597 123.588 78.1204Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.409 92.9837L68.1118 107.758C67.0653 108.019 66.0018 107.395 65.737 106.365C65.4721 105.334 66.1058 104.287 67.1526 104.027L126.45 89.2522C127.497 88.9915 128.56 89.6153 128.825 90.6458C129.09 91.6763 128.456 92.7227 127.409 92.9837Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.59 105.359L71.2929 120.134C70.2464 120.394 69.1829 119.771 68.9181 118.74C68.6533 117.71 69.2869 116.663 70.3337 116.402L129.631 101.628C130.678 101.367 131.741 101.991 132.006 103.021C132.271 104.052 131.637 105.098 130.59 105.359Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.894 140.405C101.078 148.901 95.8337 157.564 87.2027 159.714C78.572 161.864 69.7725 156.701 67.5882 148.205C65.4038 139.708 70.6487 131.046 79.2794 128.895C87.9101 126.745 96.7096 131.908 98.894 140.405Z",
    fill: "url(#paint2_linear_26801_4451)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2669 152.806C81.8282 152.915 81.3473 152.86 80.928 152.614L72.9104 147.909C72.0717 147.417 71.7971 146.349 72.2968 145.523C72.7968 144.698 73.882 144.427 74.7204 144.919L81.2196 148.733L89.5309 135.006C90.0308 134.18 91.1161 133.91 91.9545 134.402C92.7932 134.894 93.0678 135.962 92.5681 136.788L83.3516 152.01C83.1018 152.423 82.7055 152.697 82.2669 152.806Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135.739 125.384L108.702 132.121C107.655 132.381 106.592 131.758 106.327 130.727C106.062 129.697 106.696 128.65 107.742 128.389L134.78 121.653C135.827 121.392 136.89 122.016 137.155 123.046C137.42 124.077 136.786 125.123 135.739 125.384Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.767 137.159L111.729 143.895C110.682 144.156 109.619 143.532 109.354 142.502C109.089 141.471 109.723 140.424 110.77 140.164L137.807 133.427C138.854 133.166 139.917 133.79 140.182 134.82C140.447 135.851 139.813 136.898 138.767 137.159Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_4451",
    x1: 25,
    y1: 35.0286,
    x2: 167.915,
    y2: 164.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_4451",
    x1: 98.5,
    y1: 45.3148,
    x2: 98.5,
    y2: 176.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_4451",
    x1: 70.6252,
    y1: 128.408,
    x2: 107.643,
    y2: 151.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentation);
export default __webpack_public_path__ + "static/media/Documentation.715a2ac582f265380e189b6f3a1eac73.svg";
export { ForwardRef as ReactComponent };